var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarkModeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.8255C4.5 19.8255 0 15.3255 0 9.82548C0 5.12548 3.4 0.925483 8 0.0254834C8.4 -0.0745166 8.9 0.125483 9.1 0.525483C9.3 0.925483 9.2 1.42548 8.9 1.72548C7.7 2.92548 7 4.62548 7 6.32548C7 9.92548 9.9 12.8255 13.5 12.8255C15.2 12.8255 16.9 12.1255 18.1 10.9255C18.4 10.6255 18.9 10.5255 19.3 10.7255C19.7 10.9255 19.9 11.3255 19.8 11.8255C18.9 16.4255 14.7 19.8255 10 19.8255ZM5.6 3.12548C3.4 4.62548 2 7.02548 2 9.82548C2 14.2255 5.6 17.8255 10 17.8255C12.8 17.8255 15.2 16.4255 16.7 14.2255C15.7 14.6255 14.6 14.8255 13.5 14.8255C8.8 14.8255 5 11.0255 5 6.32548C5 5.22548 5.2 4.12548 5.6 3.12548Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/DarkModeIcon.4dcb0c3c62204df7349217a00764ae57.svg";
export { ForwardRef as ReactComponent };